import api from './api';

// gym-api responses are enveloped as { success, message, data, error } —
// these helpers unwrap to the `data` payload for callers.

export async function getMyGym() {
  const res = await api.get('/gyms/me');
  return res.data.data;
}

export async function createGym(payload) {
  const res = await api.post('/gyms', payload);
  return res.data.data;
}

export async function updateMyGym(payload) {
  const res = await api.put('/gyms/me', payload);
  return res.data.data;
}

export async function deleteMyGym() {
  const res = await api.delete('/gyms/me');
  return res.data.data;
}

export async function saveSlotOverride(date, slots) {
  const res = await api.put(`/gyms/me/slot-overrides/${date}`, { slots });
  return res.data.data;
}

export async function deleteSlotOverride(date) {
  const res = await api.delete(`/gyms/me/slot-overrides/${date}`);
  return res.data.data;
}

export async function uploadCoverImage(file) {
  const formData = new FormData();
  formData.append('image', file);
  const res = await api.post('/gyms/me/cover-image', formData);
  return res.data.data;
}

export async function uploadGalleryImages(files) {
  const formData = new FormData();
  for (const file of files) formData.append('images', file);
  const res = await api.post('/gyms/me/images', formData);
  return res.data.data;
}

export async function deleteGalleryImage(index) {
  const res = await api.delete(`/gyms/me/images/${index}`);
  return res.data.data;
}

export async function uploadVideo(file) {
  const formData = new FormData();
  formData.append('video', file);
  const res = await api.post('/gyms/me/video', formData);
  return res.data.data;
}

export async function deleteVideo() {
  const res = await api.delete('/gyms/me/video');
  return res.data.data;
}
